export default "__VITE_ASSET__X2_KEn_1__"